import type { StockCountStatus } from "@/redux/services/inventory/inventory.type";

// Shared by the stock counts list (badge + status filter) and the count page.
export const STOCK_COUNT_STATUS_STYLES: Record<StockCountStatus, string> = {
  in_progress: "bg-blue-100 text-blue-700",
  completed: "bg-green-100 text-green-700",
};

export const STOCK_COUNT_STATUS_LABELS: Record<StockCountStatus, string> = {
  in_progress: "En cours",
  completed: "Terminé",
};
